import {createAction, createReducer} from '@reduxjs/toolkit';

import {SpecialOfferStateType} from './specialOfferTypes';

const initialState: SpecialOfferStateType = {
    bannerContent: '',
    contentType: null,
    savedBanners: {},
    status: 'initial',
};

export const setCartSpecialOffer = createAction<
    Pick<SpecialOfferStateType, 'bannerContent'> & {contentType: 'json' | 'html'}
>('CART_SET_SPECIAL_OFFER');

export const saveBannerForSpecialOffer = createAction<{
    bannerId: string;
    content: string;
    contentType: 'json' | 'html';
}>('CART_SAVE_BANNER_SPECIAL_OFFER');

/**
 * Cart special offer cms block
 *
 * @param {ActionType<AxiosPromise>} action - Received action
 * @returns {QuoteInfoType} Cart quote data
 */
export const specialOffer = createReducer<SpecialOfferStateType>(initialState, builder =>
    builder
        .addCase(setCartSpecialOffer, (state, {payload: {bannerContent = '', contentType}}) => {
            return {
                ...state,
                bannerContent,
                contentType,
                status: 'fulfilled',
            };
        })
        .addCase(saveBannerForSpecialOffer, (state, {payload: banner}) => {
            return {
                ...state,
                savedBanners: {
                    ...state.savedBanners,
                    [banner.bannerId]: {content: banner.content, contentType: banner.contentType},
                },
            };
        }),
);
